import { FilterDocument } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';

export const useUpdateAllTasksFilterDocument = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (filterDocument: Partial<FilterDocument>) =>
      updateSettings({
        filters: {
          allTasks: filterDocument,
        },
      }),
    [updateSettings],
  );
};
